"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var sok_ui_1 = require("@caddigital/sok-ui");
var fileUploadModal_1 = require("actions/fileUploadModal");
var mapStateToProps = function (state) {
    return {
        location: state.router.location,
        files: state.fileUploadModal.files,
        uploadSettings: state.fileUploadModal.uploadSettings,
        uploadedFiles: state.fileUploadModal.uploadedFiles,
        file: state.fileUploadModal.currentUploadStatus.fileId,
        currentFolder: state.files.currentFolder,
        currentBid: state.bid.current.bid
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    onChange: function (files, location, parent) { return dispatch(fileUploadModal_1.default.setFileUploadFiles(files, location, parent)); },
    clearSelection: function () {
        return dispatch(fileUploadModal_1.default.setFileUploadFiles([], '#', null));
    },
    toggleUnzip: function (unzip) {
        return dispatch(fileUploadModal_1.default.toggleUnzip(unzip));
    },
    toggleReplace: function (replace) {
        return dispatch(fileUploadModal_1.default.toggleReplace(replace));
    }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var enhance = (0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps);
exports.default = enhance(function (props) { return (React.createElement(sok_ui_1.FileUpload, { value: props.files, multipleFiles: props.file === undefined, uploadedFiles: props.uploadedFiles, unzip: props.file !== undefined ? false : props.uploadSettings.unzip, replace: props.uploadSettings.replace, hasDuplicates: props.file !== undefined ? false : props.uploadSettings.hasDuplicates, toggleUnzip: props.toggleUnzip, toggleReplace: props.toggleReplace, onChange: function (files) {
        return props.onChange(files, props.location.pathname.replace(/\/revisions\/([\w\-]+)(\/?)$/, ''), props.currentFolder);
    }, clearSelection: props.clearSelection })); });
